import { Component, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SwPush, SwUpdate } from '@angular/service-worker'
import { ConnectionService } from 'ng-connection-service';
import { filter } from 'rxjs/operators';
const MAIN_PAGE_TITLE = "SKILLFLO Portal";
import { UpdateService } from './app.service'
import { AdminSettingsService } from './pages/full-layout-page/admin-services/adminsettings-services.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})


export class AppComponent implements OnInit, OnDestroy {

  noInternetConnection:boolean;
  
  constructor(private router: Router, 
    private swPush: SwPush, 
    private connectionService: ConnectionService,
    private updates: SwUpdate, 
    private sw: UpdateService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private adminSettingsService:AdminSettingsService,) {
  }
  
  /**
   * app component is a main component to connect all other components.
   */
  ngOnInit() {
    this.noInternetConnection=false;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    )
    .subscribe(() => {
      var rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {       
        let title = (typeof data['title'] ==="undefined") ? MAIN_PAGE_TITLE : `${data['title']} | ${MAIN_PAGE_TITLE}`;
        this.titleService.setTitle(title)})
    });

    this.adminSettingsService.getCopyRightContentSettings().subscribe(response => {
      if (response && response['copyrightContent'] != '') {
        this.adminSettingsService.changeCopyrightMsg(response['copyrightContent']);
      } else {
        this.adminSettingsService.changeCopyrightMsg("");
      }
    });
     this.getTenantData()
  }
async getTenantData() {
  const origin = window.location.origin;
  const domain = origin.split('//')[1];
  console.log(domain); // e.g., "example.com"

  this.adminSettingsService.getTenantInfobyDomain(domain).subscribe((response: any) => {
    const authHubId = response?.data?.authHubId;

    if (authHubId) {
      console.log('Setting authHubId to localStorage:', authHubId);
      localStorage.setItem('authHubId', authHubId);
    } else {
      console.warn('authHubId not found in response');
    }
  });
}

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
 
  }

  ngOnDestroy() {
   
  }
   
}